// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"510d7eef","635":"c4a980cb"}[chunkId] + ".chunk.js");